exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-news[data-v-0277cd56]{margin:0;background:#27ae60;display:inline-block;color:#fff;padding:2px 10px;border-radius:6px}.list[data-v-0277cd56]{overflow:hidden;position:relative;margin:0;width:100%;display:inline-block}.row[data-v-0277cd56]{display:block;white-space:nowrap;width:100%;position:absolute;top:-999em;left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0277cd56","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Marquee.vue
// module id = m9Op
// module chunks = 1